import "./index.scss";
import { useEffect } from "react";
import { useCheckoutContext } from "context/checkout-context";
import {
  CheckoutPaymentFormInput,
  PaymentFeedback
} from "components/UI/molecules";
import { DEFAULT_WARNING_MESSAGE, FORM_TEMPLATE } from "./utils/constants";

export const CheckoutPaymentForm = ({ toggleForm }) => {
  const {
    initializeStripe,
    submitPaymentMethod,
    paymentData,
    paymentMethodErrorMessage,
    paymentSaving
  } = useCheckoutContext();

  const hasSavedPaymentMethod = !!paymentData?.data?.length;

  useEffect(() => {
    initializeStripe();
  }, [initializeStripe]);

  return (
    <div className="checkout-payment-form">
      <div className="form-header">
        <h3>Enter new payment information</h3>
        <button onClick={toggleForm} hidden={!hasSavedPaymentMethod}>
          Cancel
        </button>
      </div>
      <PaymentFeedback
        message={paymentMethodErrorMessage || DEFAULT_WARNING_MESSAGE}
        variant={paymentMethodErrorMessage ? "warning" : "info"}
      />
      {FORM_TEMPLATE.map((input) => (
        <CheckoutPaymentFormInput key={input.id} {...input} />
      ))}
      <button
        className="submit-method-button"
        onClick={submitPaymentMethod}
        disabled={paymentSaving}
      >
        Save Method
      </button>
    </div>
  );
};
